
 /* eslint no-underscore-dangle:  0 */
 /* eslint-disable no-debugger, no-console */
 /* eslint-disable */
 
import axios from "axios";
import { setCookie,getCookie } from "cookie/cookie";
import {
    GET_USER_SIGN_IN_SUCCESS,
    GET_USER_SIGN_IN_FAIL,
    GET_USER_SIGN_IN_REQUEST,
    GET_USER_SIGN_UP_SUCCESS,
    GET_USER_SIGN_UP_FAIL,
    GET_USER_SIGN_UP_REQUEST,
    GET_USER_PROFILE_REQUEST,
    GET_USER_PROFILE_FAIL,
    GET_USER_PROFILE_SUCCESS,
    GET_DASHBOARD_REQUEST,
    GET_DASHBOARD_SUCCESS,
    GET_DASHBOARD_FAIL,
    GET_BANK_ACCOUNT_UPDATE_REQUEST,
    GET_BANK_ACCOUNT_UPDATE_SUCCESS,
    GET_BANK_ACCOUNT_UPDATE_FAIL,
    GET_USER_SIGN_OUT_REQUEST,
    GET_USER_SIGN_OUT_SUCCESS,
    GET_USER_SIGN_OUT_FAIL,
} from "../types/user";

import { apiVersionPrefix,apiBaseUrl } from "../../config/index";
import { removeCookie } from "cookie/cookie";

export const signIn = (email, password,navigate) => async (dispatch) => {
   try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Access-Control-Allow-Origin": "*"
            },
        };
        dispatch({
            type: GET_USER_SIGN_IN_REQUEST,
        });
        const { data } = await axios.post(
            `${apiBaseUrl}${apiVersionPrefix}/user/login`,
            { email, password },
            config
        );
        if(data){
            setCookie("token", data.token)
            dispatch({
                type: GET_USER_SIGN_IN_SUCCESS,
                payload: data,
            });
            navigate('/dashboard')
        }

   }
    catch(error){
        dispatch({
            type: GET_USER_SIGN_IN_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};
export const signUp = (formData,navigate) => async (dispatch) => {
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                'Access-Control-Allow-Origin': '*',
                
            },
        };
        dispatch({
            type: GET_USER_SIGN_UP_REQUEST,
        });
        const { data } = await axios.post(
            `
            ${apiBaseUrl}${apiVersionPrefix}/user/signup`,
            formData,
            config
        );
        if(data){
            setCookie("token", data.token)
            dispatch({
                type: GET_USER_SIGN_UP_SUCCESS,
                payload: data,
            });
            navigate("/dashboard");
        }
    }
    catch(error){
        dispatch({
            type: GET_USER_SIGN_UP_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}
export const getUserProfile = () => async (dispatch) => {
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getCookie("token")}`               
            },
        };
        dispatch({
            type: GET_USER_PROFILE_REQUEST,
        });
        const { data } = await axios.get(
            `
            ${apiBaseUrl}${apiVersionPrefix}/user/me`,
            config
        );
        if(data){
            dispatch({
                type: GET_USER_PROFILE_SUCCESS,
                payload: data,
            });
        }
    }
    catch(error){
        dispatch({
            type: GET_USER_PROFILE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}
export const logout = () => async (dispatch) => {
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getCookie("token")}`
            },
        };
        dispatch({
            type: GET_USER_SIGN_OUT_REQUEST,
        });
        const { data } = await axios.get(
            `
            ${apiBaseUrl}${apiVersionPrefix}/user/logout`,
            config
        );
       
        if(data){
            removeCookie('token')
            localStorage.clear()
            window.location.reload();
            dispatch({
                type: GET_USER_SIGN_OUT_SUCCESS,
                payload: data,
            });
        }
    }
    catch(error){
        dispatch({
            type: GET_USER_SIGN_OUT_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}



export const getDashboard = () => async (dispatch) => {
    try{
        
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getCookie("token")}`               
            },
        };
        dispatch({
            type: GET_DASHBOARD_REQUEST,
        });
        const { data } = await axios.get(
            `
            ${apiBaseUrl}${apiVersionPrefix}/user/dashboard`,
            config
        );
        if(data){
            dispatch({
                type: GET_DASHBOARD_SUCCESS,
                payload: data,
            });
        }
    }
    catch(error){
        dispatch({
            type: GET_DASHBOARD_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}
export const updateBank=(formData)=>async(dispatch)=>{
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getCookie("token")}`               
            },
        };
        dispatch({
            type: GET_BANK_ACCOUNT_UPDATE_REQUEST,
        });
        const { data } = await axios.put(
            `
            ${apiBaseUrl}${apiVersionPrefix}/user/update-bank-balance`,
            formData,
            config
        );
        if(data){
            dispatch({
                type: GET_BANK_ACCOUNT_UPDATE_SUCCESS,
                payload: data,
            });
        }
    }
    catch(error){
        dispatch({
            type: GET_BANK_ACCOUNT_UPDATE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}

export const updateUserCash = (formData) => async (dispatch) => {
    try{
        const config = {
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${getCookie("token")}`               
            },
        };
        dispatch({
            type: GET_USER_PROFILE_REQUEST,
        });
        const { data } = await axios.put(
            `
            ${apiBaseUrl}${apiVersionPrefix}/user/update-user-cash`,
            formData,
            config
        );
        if(data){
            dispatch({
                type: GET_USER_PROFILE_SUCCESS,
                payload: data,
            });
        }
    }
    catch(error){
        dispatch({
            type: GET_USER_PROFILE_FAIL,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
}
